import { useLayoutEffect } from 'react'
import { treeStore } from '@/msgdeskRuntime/state'

export function useInitialLegacyHtml(initialHtml?: string | null) {
  useLayoutEffect(() => {
    if (!initialHtml) return
    treeStore.parseAndNormalize(initialHtml, { mode: 'append', isInitial: true })
  }, [initialHtml])
}
